module.exports = __webpack_public_path__ + "img/openquery.b75e663c.png";